import {
    post,
    dow,
    exportData
} from './http'

/**
 * 公共模块
 */

// 登录接口
export const login = p => post('api/common/login', p)
// 获取用户信息
export const getUser = p => post('api/common/getUser', p)
// 获取所有公司
export const getAllCompany = p => post('salesadmin/getAllCompany', p)
// 查看销售代表管理员下的销售代表
export const getAllSalesReps = p => post('salesadmin/getAllSalesReps', p)
// 查看销售代表管理员下的医生接口
export const getAllPhysician = p => post('salesadmin/getAllPhysician', p)
// 查看销售代表下的医生接口
export const getSalesRepPhysician = p => post('salesRep/getAllPhysician', p)
export const getImagingEngineerPhysician = p => post('imagingEngineer/getAllPhysician', p)
// 查看销售代表下的医生接口
// export const getPhysician = p => post('physician/getAllPhysician', p)
// 获取所有医院
export const getAllHospital = p => post('api/common/getAllHospital', p)
export const getAllHospitalByPhysician = p => post('api/common/getAllHospitalByPhysician', p)
// 查询用户软件许可证列表
export const getLicenses = p => post('api/common/getLicenses', p)
// 获取所有科室
export const getAllDept = p => post('api/common/getAllDept', p)
// 获取消息页面数据副本
export const getMessage = p => post('api/public/notic/getMessage', p)
// 获取当前医生所绑定的所有医院列表
export const allHospital = p => post('api/public/notic/allHospital', p)
// 医生列表下拉框
export const allPhysician = p => post('api/public/notic/allPhysician', p)
// 消息列表-消息归档
export const updateMessStatus = p => post('api/common/updateMessStatus', p)
// 文件上传
export const fileUpload = p => post('api/common/uploadOrg', p)
// 获取全部消息通知
export const getAllMessage = p => post('api/common/getAllMessage', p)
// 开始上传
export const uploadOrgBegin = p => post('api/common/uploadOrgBegin', p)
export const uploadSolveBegin = p => post('api/common/uploadSolveBegin', p)
// 结束上传
export const uploadOrgDone = p => post('api/common/uploadOrgDone', p)
export const uploadSolveDone = p => post('api/common/uploadSolveDone', p)

// 案例加急
export const editCustomInfoPriority = p => post('api/imagingEngineer/custom/editCustomInfoPriority', p)
// 添加医生医院
export const updateHospitalInPhysician = p => post('api/common/updateHospitalInPhysician', p)
// 开始下载
export const downloadResultResource = p => dow('api/common/downloadResultResource', p)
export const downloadOrgResource = p => dow('api/common/downloadOrgResource', p)
export const downloadFile = p => dow('api/common/downloadFile', p)
export const delFile = p => post('api/common/deleteFile', p)
// 获取该用户消息配置
export const getNoticeSetup = p => post('api/common/getNoticeSetup', p)
// 设置消息配置
export const setNoticeSetup = p => post('api/common/setNoticeSetup', p)
// 忘记密码发送邮箱
export const resetPasswordPre = p => post('api/common/resetPasswordPre', p)
// 获取文件路径列表
export const listAllFiles = p => post('api/common/listAllFiles', p)
// 获得当前案例所有的事件日志
export const getAllLog = p => post('api/common/getAllLog', p)
// 添加事件
export const addCaseLog = p => post('api/common/addCaseLog', p)
// 导出医生
export const exportPhysician = p => exportData('api/common/exportPhysician', p)
// 导出销售代表
export const exportSales = p => exportData('api/common/exportSales', p)
// 导出自动案例的log
export const exportAutoCaseLog = p => exportData('api/common/exportAutoCaseLog', p)
// 导出后处理案例log
export const exportCustomCaseLog = p => exportData('api/common/exportCustomCaseLog', p)
// 获取当前医生所属的销售代表信息
export const salesByPhysician = p => post('api/common/salesByPhysician', p)
// 获取当前医生所属的销售代表信息
export const setPassword = p => post('api/common/setPassword', p)
export const resetPassword = p => post('api/common/resetPassword', p)
/**
 * 销售代表管理员模块
 */
export const corporation = {
    // 自动导入模块
    automatic:{
        // 获取自动导入表格数据
        getAutomaticData: p => post('api/corporation/automatic/getAutomaticData', p),
        // 获取表格详情
        getAutomaticInfo: p => post('api/corporation/automatic/getAutomaticInfo', p),
        // 获取当先详情下的所有评论
        getAutomaticComment: p => post('api/corporation/automatic/getAutomaticComment', p),
        // 添加新评论
        addAutomaticComment: p => post('api/corporation/automatic/addAutomaticComment', p)
    },
    // 影像管理模块
    custom:{
        // 获取影像处理表格数据
        getCustomData: p => post('api/corporation/custom/getCustomData', p),
        // 获取影像详情
        getCustomInfo: p => post('api/corporation/custom/getCustomInfo', p),
        // 获取当前影像详情下的所有评论
        getCustomComment: p => post('api/corporation/custom/getCustomComment', p),
        // 编辑影像详情
        editCustomInfo: p => post('api/corporation/custom/editCustomInfo', p),
        // 取消申请操作反馈
        customRequestCancellation: p => post('api/corporation/custom/customRequestCancellation', p),
        // 新建案例
        addNewCase: p => post('api/corporation/custom/addNewCase', p),
        // 添加新评论
        addCustomComment: p => post('api/corporation/custom/addCustomComment', p),
        // 通知更新
        uploadNewFileNotice: p => post('api/corporation/custom/uploadNewFileNotice', p)
    },
    // 管理模块
    management:{
        // 获取管理页面数据
        getManagementData: p => post('api/corporation/management/getManagementData', p),
        // 新增用户
        inviteNewUser: p => post('api/corporation/management/inviteNewUser', p),
        // 编辑表格详情
        editInfo: p => post('api/corporation/management/editInfo', p),
        // 修改用户邮箱
        changeEmailLogin: p => post('api/corporation/management/changeEmailLogin', p),
        // 重置密码
        resetPassword: p => post('api/corporation/management/resetPassword', p),
        // 获取用户证书
        manageSoftwareLicenses: p => post('api/corporation/management/manageSoftwareLicenses', p),
        // 新增证书
        addSoftwareLicenses: p => post('api/corporation/management/addSoftwareLicenses', p),
        // 删除证书
        delSoftwareLicenses: p => post('api/corporation/management/delSoftwareLicenses', p),
        // 编辑证书
        editSoftwareLicenses: p => post('api/corporation/management/editSoftwareLicenses', p)
    },
    // 个人中心
    mine:{
        // 获取个人中心详情
        getInformation: p => post('api/corporation/mine/getInformation', p),
        // 修改个人中心邮箱
        changeEmailLogin: p => post('api/corporation/mine/changeEmailLogin', p),
        // 修改我的密码
        changePassword: p => post('api/corporation/mine/changePassword', p),
        // 修改我的信息
        myProfile: p => post('api/corporation/mine/myProfile', p),
        // 修改配置开关
        changeSwitch: p => post('api/corporation/mine/changeSwitch', p),
        setPassword: p => post('api/corporation/mine/setPassword', p)
    }
}

/*
** 医生模块
*/
export const physician = {
    // 自动导入模块
    automatic:{
        // 获取自动导入表格数据
        getAutomaticData: p => post('api/physician/automatic/getAutomaticData', p),
        // 获取表格详情
        getAutomaticInfo: p => post('api/physician/automatic/getAutomaticInfo', p),
        // 获取当先详情下的所有评论
        getAutomaticComment: p => post('api/physician/automatic/getAutomaticComment', p),
        // 添加新评论
        addAutomaticComment: p => post('api/physician/automatic/addAutomaticComment', p)
    },
    // 影像管理模块
    custom:{
        // 获取影像处理表格数据
        getCustomData: p => post('api/physician/custom/getCustomData', p),
        // 获取影像详情
        getCustomInfo: p => post('api/physician/custom/getCustomInfo', p),
        // 获取当前影像详情下的所有评论
        getCustomComment: p => post('api/physician/custom/getCustomComment', p),
        // 编辑影像详情
        editCustomInfo: p => post('api/physician/custom/editCustomInfo', p),
        // 取消申请操作反馈
        customRequestCancellation: p => post('api/physician/custom/customRequestCancellation', p),
        // 新建案例
        addNewCase: p => post('api/physician/custom/addNewCase', p),
        // 添加新评论
        addCustomComment: p => post('api/physician/custom/addCustomComment', p),
        // 通知更新
        uploadNewFileNotice: p => post('api/physician/custom/uploadNewFileNotice', p)
    },
    // 管理模块
    // management:{
    //     // 获取管理页面数据
    //     getManagementData: p => post('api/corporation/management/getManagementData', p),
    //     // 新增用户
    //     inviteNewUser: p => post('api/corporation/management/inviteNewUser', p),
    //     // 编辑表格详情
    //     editInfo: p => post('api/corporation/management/editInfo', p),
    //     // 修改用户邮箱
    //     changeEmailLogin: p => post('api/corporation/management/changeEmailLogin', p),
    //     // 重置密码
    //     resetPassword: p => post('api/corporation/management/resetPassword', p),
    //     // 获取用户证书
    //     manageSoftwareLicenses: p => post('api/corporation/management/manageSoftwareLicenses', p),
    //     // 新增证书
    //     addSoftwareLicenses: p => post('api/corporation/management/addSoftwareLicenses', p),
    //     // 删除证书
    //     delSoftwareLicenses: p => post('api/corporation/management/delSoftwareLicenses', p)
    // },
    // 个人中心
    mine:{
        // 获取个人中心详情
        getInformation: p => post('api/physician/mine/getInformation', p),
        // 修改个人中心邮箱
        changeEmailLogin: p => post('api/physician/mine/changeEmailLogin', p),
        // 修改我的密码
        changePassword: p => post('api/physician/mine/changePassword', p),
        // 修改我的信息
        myProfile: p => post('api/physician/mine/myProfile', p),
        // 修改配置开关
        changeSwitch: p => post('api/physician/mine/changeSwitch', p),
        setPassword: p => post('api/physician/mine/setPassword', p)
    }
}

/*
** 销售代表模块
*/
export const salesRep = {
    // 自动导入模块
    automatic:{
        // 获取自动导入表格数据
        getAutomaticData: p => post('api/salesRep/automatic/getAutomaticData', p),
        // 获取表格详情
        getAutomaticInfo: p => post('api/salesRep/automatic/getAutomaticInfo', p),
        // 获取当先详情下的所有评论
        getAutomaticComment: p => post('api/salesRep/automatic/getAutomaticComment', p),
        // 添加新评论
        addAutomaticComment: p => post('api/salesRep/automatic/addAutomaticComment', p)
    },
    // 影像管理模块
    custom:{
        // 获取影像处理表格数据
        getCustomData: p => post('api/salesRep/custom/getCustomData', p),
        // 获取影像详情
        getCustomInfo: p => post('api/salesRep/custom/getCustomInfo', p),
        // 获取当前影像详情下的所有评论
        getCustomComment: p => post('api/salesRep/custom/getCustomComment', p),
        // 编辑影像详情
        editCustomInfo: p => post('api/salesRep/custom/editCustomInfo', p),
        // 取消申请操作反馈
        customRequestCancellation: p => post('api/salesRep/custom/customRequestCancellation', p),
        // 新建案例
        addNewCase: p => post('api/salesRep/custom/addNewCase', p),
        // 添加新评论
        addCustomComment: p => post('api/salesRep/custom/addCustomComment', p),
        // 通知更新
        uploadNewFileNotice: p => post('api/salesRep/custom/uploadNewFileNotice', p)
    },
    // 管理模块
    management:{
        // 获取管理页面数据
        getManagementData: p => post('api/salesRep/management/getManagementData', p),
        // 新增用户
        inviteNewUser: p => post('api/salesRep/management/inviteNewUser', p),
        // 编辑表格详情
        editInfo: p => post('api/salesRep/management/editInfo', p),
        // 修改用户邮箱
        changeEmailLogin: p => post('api/salesRep/management/changeEmailLogin', p),
        // 重置密码
        resetPassword: p => post('api/salesRep/management/resetPassword', p),
        // 获取用户证书
        manageSoftwareLicenses: p => post('api/salesRep/management/manageSoftwareLicenses', p),
        // 新增证书
        addSoftwareLicenses: p => post('api/salesRep/management/addSoftwareLicenses', p),
        // 删除证书
        delSoftwareLicenses: p => post('api/salesRep/management/delSoftwareLicenses', p),
        // 编辑证书
        editSoftwareLicenses: p => post('api/salesRep/management/editSoftwareLicenses', p)
    },
    // 个人中心
    mine:{
        // 获取个人中心详情
        getInformation: p => post('api/salesRep/mine/getInformation', p),
        // 修改个人中心邮箱
        changeEmailLogin: p => post('api/salesRep/mine/changeEmailLogin', p),
        // 修改我的密码
        changePassword: p => post('api/salesRep/mine/changePassword', p),
        // 修改我的信息
        myProfile: p => post('api/salesRep/mine/myProfile', p),
        // 修改配置开关
        changeSwitch: p => post('api/salesRep/mine/changeSwitch', p),
        setPassword: p => post('api/salesRep/mine/setPassword', p)
    }
}

/**
 * 影像工程师模块
 */
export const imagingEngineer = {
    // 自动导入模块
    // automatic:{
    //     // 获取自动导入表格数据
    //     getAutomaticData: p => post('api/corporation/automatic/getAutomaticData', p),
    //     // 获取表格详情
    //     getAutomaticInfo: p => post('api/corporation/automatic/getAutomaticInfo', p),
    //     // 获取当先详情下的所有评论
    //     getAutomaticComment: p => post('api/corporation/automatic/getAutomaticComment', p),
    //     // 添加新评论
    //     addAutomaticComment: p => post('api/corporation/automatic/addAutomaticComment', p)
    // },
    // 影像管理模块
    custom:{
        // 获取影像处理表格数据
        getCustomData: p => post('api/imagingEngineer/custom/getCustomData', p),
        // 获取影像详情
        getCustomInfo: p => post('api/imagingEngineer/custom/getCustomInfo', p),
        // 获取当前影像详情下的所有评论
        getCustomComment: p => post('api/imagingEngineer/custom/getCustomComment', p),
        addCustomComment: p => post('api/imagingEngineer/custom/addCustomComment', p),
        // 编辑影像详情
        editCustomInfo: p => post('api/imagingEngineer/custom/editCustomInfo', p),
        // 取消申请操作反馈
        customRequestCancellation: p => post('api/imagingEngineer/custom/customRequestCancellation', p),
        // 新建案例
        addNewCase: p => post('api/imagingEngineer/custom/addNewCase', p),
        // 接受案例
        acceptTheCase: p => post('api/imagingEngineer/custom/acceptTheCase', p),
        // 驳回案件
        rejectTheCase: p => post('api/imagingEngineer/custom/rejectTheCase', p),
        // 继续处理
        resumeProcessing: p => post('api/imagingEngineer/custom/resumeProcessing', p),
        // 取消案子
        cancelThisCase: p => post('api/imagingEngineer/custom/cancelThisCase', p),
        // 暂缓案子
        onHold: p => post('api/imagingEngineer/custom/onHold', p),
        // 完成案子
        complete: p => post('api/imagingEngineer/custom/complete', p),
        // 返回处理案子
        backToProcessing: p => post('api/imagingEngineer/custom/backToProcessing', p),
        // 更改案件状态
        opCaseStatus: p => post('api/imagingEngineer/custom/opCaseStatus', p),
        // 通知更新
        uploadNewFileNotice: p => post('api/imagingEngineer/custom/uploadNewFileNotice', p)
    },
    // 管理模块
    management:{
        // 获取管理页面数据
        getManagementData: p => post('api/imagingEngineer/management/getManagementData', p),
        // 新增用户
        inviteNewUser: p => post('api/imagingEngineer/management/inviteNewUser', p),
        // 编辑表格详情
        editInfo: p => post('api/imagingEngineer/management/editInfo', p),
        // 修改用户邮箱
        changeEmailLogin: p => post('api/imagingEngineer/management/changeEmailLogin', p),
        // 重置密码
        resetPassword: p => post('api/imagingEngineer/management/resetPassword', p),
        // 获取用户证书
        manageSoftwareLicenses: p => post('api/imagingEngineer/management/manageSoftwareLicenses', p),
        // 新增证书
        addSoftwareLicenses: p => post('api/imagingEngineer/management/addSoftwareLicenses', p),
        // 删除证书
        delSoftwareLicenses: p => post('api/imagingEngineer/management/delSoftwareLicenses', p)
    },
    // 个人中心
    mine:{
        // 获取个人中心详情
        getInformation: p => post('api/imagingEngineer/mine/getInformation', p),
        // 修改个人中心邮箱
        changeEmailLogin: p => post('api/imagingEngineer/mine/changeEmailLogin', p),
        // 修改我的密码
        changePassword: p => post('api/imagingEngineer/mine/changePassword', p),
        // 修改我的信息
        myProfile: p => post('api/imagingEngineer/mine/myProfile', p),
        // 修改配置开关
        changeSwitch: p => post('api/imagingEngineer/mine/changeSwitch', p),
        setPassword: p => post('api/imagingEngineer/mine/setPassword', p)
    }
}
